import * as React from 'react';
import {connect} from 'react-redux';
import {IconButton, WithStyles, withStyles,} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { EditPaneStyle } from './EditPane.style';
import OriginalWeek from './OriginalWeek';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { addDays, isSameDay } from '@helpers/DateHelper';
import { schoolAgeFromFamily } from '@helpers/schoolHelper';
import SCHOOL_TYPES from '@constants/schoolTypes';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { IHandoverData } from '../calendar.types';
import ArrowIcon from "@material-ui/icons/ArrowForwardIosRounded";
import BackArrowIcon from "@material-ui/icons/ArrowBackIosRounded";
import { blueBackgroundColor } from 'src/main.style';
import DayVisitChange from '../DayVisitChange';
import { describeScheduleChanges, IChangeHandover, IScheduleChangeDescription } from '../changeDisplayHelper';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  step:number;
  showKidChange:boolean;
  week:number;
  visualization: "TEXT"|"IMAGE";
}

interface IProps extends WithStyles<typeof EditPaneStyle> {
  inEditMode:boolean;
  family:IFamilyMember[];
  open:boolean;
  close:() => void;
  originalSchedule?:ISchedule;
  schedule?:ISchedule;
  changes:IDateRange[];
  kidChanges:{before:number[],now:number[]}|undefined;
  eraseChange:boolean;
  setFocusDate: (year:number,month:number,date:number) => void;
  setCalendarHighlight: (dates:IDateRange[]) => void;
  localization:"se"|"en";
}

const PANE_MIN_HEIGHT = 250;
// how far below the minimum height the pane has to be dragged before it closes
const PANE_CLOSE_DISTANCE = 40;

class ShowChangesPane extends React.Component<IProps, IState> {

  private paneRef:React.RefObject<HTMLDivElement>;
  private paneStart: number = 0;
  private paneHeight:number = 0;
  private isMouseDragging:boolean = false;

  constructor(props: IProps) {
    super(props);
    
    this.paneRef = React.createRef();


    this.state = {
      step:0,
      week:0,
      showKidChange:false,
      visualization:"TEXT",
    };

  }

  public componentDidMount(): void {
    this.setHeight(this.props.open?380:0);
  }

  public componentWillUnmount(): void {
    this.detachMouseHandlers();
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (this.props.open !== prevProps.open) {
      this.setHeight(this.props.open?380:0);
      if (this.props.open) {
        this.setStep(0);
        this.setState({showKidChange:(this.props.kidChanges !== undefined)});
      } else {
        this.setState({step:0, showKidChange:(this.props.kidChanges !== undefined)});
      }
    }
  } 


  public render() {
    const {showKidChange} = this.state;
    const {classes} = this.props;

    let currentElement:JSX.Element;
    if (this.props.eraseChange) {
      currentElement = this.renderEraseChange();
    } else if (showKidChange) {
      currentElement = this.renderKidChange();
    } else {
      currentElement = this.renderCalChange();
    }

    return(<>
      <div className={classes.backdrop} style={{opacity:(this.props.open?1:0), pointerEvents:(this.props.open?"auto":"none")}}/>
      <div className={classes.pane} ref={this.paneRef}
        style={{display:(this.props.inEditMode?'flex':'none')}}>
        <div className={classes.paneDragger} onClick={() => {return;}} style={{cursor:'ns-resize'}}
          onTouchStart={(e) => this.moveStart(e)} 
          onTouchMove={(e) => this.moveMove(e)} 
          onTouchEnd={(e) => this.moveEnd(e)}
          onMouseDown={this.handleMouseDown} ><div className={classes.paneMarker}/>
        </div>
        {currentElement}
      </div></>
    )
  }

  private renderCalChange() {
    const {classes, changes, kidChanges} = this.props;
    const {step} = this.state;

    let focus = (step < changes.length)?(new Date(changes[step].start)):(new Date());    
    let needWeekStep:boolean = false;

    if (step < changes.length) {
      let spinDate = new Date(focus);
      while (spinDate.getDay() !== 1) {
        spinDate = addDays(spinDate,1);
      }
      if (spinDate.getTime() < changes[step].end) {
        needWeekStep = true;
      }
      if (needWeekStep && this.state.week > 0) {
        if (this.state.week > 1) {
          spinDate = addDays(spinDate,7*(this.state.week-1));
        }
        focus = spinDate;
      }
    }

    let changedDate:JSX.Element|undefined;

    if (changes.length > step) {
      const start = new Date(changes[step].start);
      const end = new Date(changes[step].end - (1000*60*60*12));
      const dateString = isSameDay(start,end)
        ?tn.formatDateDayMonthYear(start)
        :(tn.formatDateDayMonthYear(start)+" - "+tn.formatDateDayMonthYear(end))
      changedDate = <div className={classes.paneChangeDaysStep} style={{ fontSize: '12px', fontWeight: 600}}>
        {dateString}
      </div>
    }

    let changeVisualization:JSX.Element;
    if (this.state.visualization === "TEXT") {
      if (step < changes.length && this.props.open === true && this.props.inEditMode === true) {
        changeVisualization = this.generateChangesText(this.props.originalSchedule, this.props.schedule, changes[step]);
      } else {
        changeVisualization = <div>{tn.lang.unknown}</div>
      }
    } else {
      if (this.props.open === true && this.props.inEditMode === true) {
        changeVisualization = (<><div key="1" className={classes.changeScheduleHeader}>{tn.lang.calScheduleSuggestion}</div>
          <OriginalWeek  key="2" 
            style={{height:80, backgroundColor:blueBackgroundColor, margin:'0 10px', borderBottom: '1px solid #63636363',
              borderLeft: '1px solid #63636321', boxShadow:'0px 0px 15px 5px #5d395fa6', overflow:'hidden'}}
            localization={this.props.localization}
            focusDay={focus}
            isEditing={true}
            importedEvents={[]}
            highlight={changes}
            scheduleOne={this.props.schedule}
            scheduleTwo={undefined}
            scheduleThree={undefined} 
            setFocusDate={(year,month,date) => this.switchWeek(year,month,date, focus)} />
          <div  key="3" className={classes.changeScheduleHeader}>{tn.lang.calOriginal}</div>
          <OriginalWeek  key="4" 
            style={{height:80, backgroundColor:blueBackgroundColor, margin:'0 10px', borderBottom: '1px solid #63636363',
              borderLeft: '1px solid #63636321', overflow:'hidden'}}
            localization={this.props.localization}
            focusDay={focus}
            isEditing={true}
            importedEvents={[]}
            highlight={changes}
            scheduleOne={this.props.originalSchedule}
            scheduleTwo={undefined}
            scheduleThree={undefined} 
            setFocusDate={(year,month,date) => this.switchWeek(year,month,date, focus)} /></>);
      } else {
        changeVisualization = <div>{tn.lang.unknown}</div>
      }
      
    }

    return (
        <div className={classes.paneChange}>
          <div className={classes.paneOptions} style={{paddingBottom: '4px', paddingTop:10}}>
            <Button className={classes.paneOption} style={{textAlign: 'start'}}  startIcon={<BackArrowIcon />} classes={{text:classes.backButton}}
              onClick={() => this.props.close()}>{tn.lang.back}</Button>
            <div className={classes.paneOption} 
              style={{textAlign: 'center', width:'calc(200% / 3)', gap: '6px', display: 'flex', justifyContent: 'center'}}
              onClick={() => this.setState({visualization:this.state.visualization==="TEXT"?"IMAGE":"TEXT"})}>
              {tn.lang.calShowAs(this.state.visualization)}
            </div>
          </div>
          
          {changeVisualization}

          <div className={classes.changeScheduleHeader} style={{ padding: '8px 0px 0px', marginBottom: '-5px', flex:0}}>{changedDate}</div>
          <div className={classes.paneChangeDaysStep} style={{paddingBottom: '8px'}}>
            <IconButton onClick={() => this.setStep(step-1)} classes={{root:classes.paneChangeArrowButton}}
              disabled={step<=0 && kidChanges === undefined}>
              <BackArrowIcon />
            </IconButton>
            <div style={{fontWeight: 600, fontSize:'20px'}}>{tn.lang.calChange((step+1),changes.length)}</div>
            <IconButton onClick={() => this.setStep(step+1)}  classes={{root:classes.paneChangeArrowButton}}
              disabled={step>=(changes.length-1)} >
              <ArrowIcon />
            </IconButton>
          </div>
        </div>
    );
  }

  private setHeight(height:number) {
    if (this.paneRef.current) {
      this.paneRef.current.style.height = ((this.props.open?height:0)+"px");
      this.paneRef.current.style.maxHeight = ((this.props.open?height:0)+"px");
      this.paneRef.current.style.minHeight = ((this.props.open?height:0)+"px");
      this.paneRef.current.style.border = ((this.props.open
        ?"1px solid #cdcdcd"
        :"0px solid #cdcdcd"
      ));

      this.paneRef.current.style.boxShadow = ((this.props.open
        ?'0px 0px 10px rgba(113, 101, 113, 0.27)'
        :'0px 0px 10px rgba(113, 101, 113, 0)'));
      this.paneHeight = (this.props.open?height:0);
    }
  }

  private generateChangesText(originalSchedule:ISchedule|undefined, newSchedule:ISchedule|undefined, range:IDateRange):JSX.Element {
    if (originalSchedule === undefined || newSchedule === undefined ) {
      return (<div>{tn.lang.unknown}</div>);
    }
    const changes = describeScheduleChanges(originalSchedule, newSchedule, range)
      .map((description, index) => this.generateChange(description, index+1));
    return (<div className={this.props.classes.changeInfoView}>{changes}</div>);
  }

  private generateChange(description:IScheduleChangeDescription, key:number):JSX.Element {
    if (description.type === "TAKES_OVER") {
      return this.generateTakesOver(description.from, description.to, description.fromHandover, description.toHandover,
        tn.familyMemberName(description.parent, this.props.family), key);
    } else if (description.type === "DAY_VISIT") {
      return this.generateDayVisit(description.from, description.to, tn.familyMemberName(description.parent, this.props.family),
        key, description.oldFrom, description.oldTo);
    } else if (description.type === "DAY_VISIT_REMOVED") {
      return this.generateDayVisit(description.from, description.to,
        tn.familyMemberName(description.parent, this.props.family), key, undefined, undefined, true);
    } else {
      return this.generateExchangeChange(description.from, description.to,
        tn.familyMemberName(description.fromParent, this.props.family),
        tn.familyMemberName(description.toParent, this.props.family), key);
    }
  }

  private getDay(time:number):string {
    const day:Date = new Date(time);
    return tn.formatDateMonthShort(day);
  }

  private getSchool():SCHOOL_TYPES|undefined {
    const schedule = this.props.schedule?this.props.schedule:this.props.originalSchedule;
    return schedule?schedule.school:undefined;
  }

  private getLocation(handover:IHandoverData|null):string {
    if (handover === null) {
      return tn.lang.unknown;
    } else if (handover.atSchool) {
      return tn.lang.schedulePickupSchool(this.getSchool(), schoolAgeFromFamily(this.props.family));
    } else {
      return tn.lang.handoverTimeAndPlace(new Date(handover.time), handover.location);
    }
  }

  private generateTakesOver(from:number, to:number, fromLoc:IChangeHandover,
    toLoc:IChangeHandover, parent:string, key:number):JSX.Element {
    return (
      <div className={this.props.classes.changeInfoBox} key={"change"+key}>
        <div className={this.props.classes.changeInfoHeader}>
          <span style={{fontWeight:600, marginRight: '5px'}}>{parent}</span>{tn.lang.calTakesResponsibility}
        </div>
        <div className={this.props.classes.changeInfoRow} style={{marginBottom:'20px'}}>
          <div className={this.props.classes.changeInfoColumn}>
            <div className={this.props.classes.changeInfoLabel}>{tn.lang.from}</div>
            <div className={this.props.classes.changeInfoValue}>{this.getDay(from)}</div>
          </div>
          <div className={this.props.classes.changeInfoColumn}>
            <div className={this.props.classes.changeInfoLabel}>{tn.lang.to}</div>
            <div className={this.props.classes.changeInfoValue}>{this.getDay(to)}</div>
          </div>
        </div>
        <div className={this.props.classes.changeInfoRow}>
          {fromLoc==="CONTINUE"?"":(tn.lang.handoverExplain1+this.getDay(from)+tn.lang.handoverExplain2+this.getLocation(fromLoc))}
        </div>
        <div className={this.props.classes.changeInfoRow}>
          {toLoc==="CONTINUE"?"":(tn.lang.handoverExplain1+this.getDay(to)+tn.lang.handoverExplain2+this.getLocation(toLoc))}
        </div>
      </div>);
  }

  private generateDayVisit(from:IHandoverData, to:IHandoverData, parent:string, key:number,
    oldFrom?:IHandoverData, oldTo?:IHandoverData, removed?:boolean):JSX.Element {
    return (
      <DayVisitChange key={"change"+key} boxClassName={this.props.classes.changeInfoBox} parent={parent}
        from={from} to={to} oldFrom={oldFrom} oldTo={oldTo} removed={removed}
        schoolName={tn.lang.calDayVisitSchool(this.getSchool(), schoolAgeFromFamily(this.props.family))}/>);
  }

  private generateExchangeChange(from:IHandoverData, to:IHandoverData, fromParent:string, toParent:string,
    key:number):JSX.Element {
    return (
      <div className={this.props.classes.changeInfoBox} key={"change"+key}>
        <div className={this.props.classes.changeInfoCaption}>
          {tn.lang.calHandoverChangeWas(fromParent, toParent)}
        </div>
        <div className={this.props.classes.changeInfoRow} style={{marginBottom:'20px'}}>
          <div className={this.props.classes.changeInfoValue} style={{textDecoration:'line-through', opacity:0.5}}>
            {tn.lang.calHandoverChangeTime(new Date(from.time), this.getLocation(from))}
          </div>
        </div>
        <div className={this.props.classes.changeInfoCaption}>
          {tn.lang.calHandoverChangeTo}
        </div>
        <div className={this.props.classes.changeInfoRow}>
          <div className={this.props.classes.changeInfoValue} style={{fontWeight:700}}>
            {tn.lang.calHandoverChangeTime(new Date(to.time), this.getLocation(to))}
          </div>
        </div>
      </div>);
  }


  private switchWeek(year:number,month:number,date:number, currentFocusStart:Date) {

    if (this.state.step < this.props.changes.length) {

      const clicked = new Date(year,month,date);

      let direction:"BACK"|"NO"|"FORWARD" = "NO";

      if (clicked.getDay() === 1 || clicked.getDay() === 2) {
        direction = "BACK";
      } else if (clicked.getDay() === 6 || clicked.getDay() === 0) {
        direction = "FORWARD";
      }
    
      if (direction === "BACK" && currentFocusStart.getTime() > this.props.changes[this.state.step].start && this.state.week > 0 ) {
        this.setState({week:this.state.week - 1});
      }
      if (direction === "FORWARD" && clicked.getTime() < this.props.changes[this.state.step].end ) {
        this.setState({week:this.state.week + 1});
      }

    }
  }

  private renderEraseChange() {
    const {classes} = this.props;

    return (
        <div className={classes.paneChange}>
          <div className={classes.paneOptions} style={{paddingBottom: '4px', paddingTop:10}}>
            <Button className={classes.paneOption} style={{textAlign: 'start'}} startIcon={<BackArrowIcon />}
              classes={{text:classes.backButton}} onClick={() => this.props.close()}>{tn.lang.back}</Button>
            <div style={{flex: 1}} />
          </div>
          <div style={{padding: '16px', flex: 1, fontWeight: 600, textAlign: 'center'}}>
            {tn.lang.calEraseChange(tn.lang.scheduleNameNew(this.props.schedule))}
          </div>
        </div>
    );
  }

  private renderKidChange() {
    const {classes, kidChanges, changes} = this.props;

    return (
        <div className={classes.paneChange}>
          <div className={classes.paneOptions} style={{paddingBottom: '4px', paddingTop:10}}>
            <Button className={classes.paneOption} style={{textAlign: 'start'}} startIcon={<BackArrowIcon />}
              classes={{text:classes.backButton}} onClick={() => this.props.close()}>{tn.lang.back}</Button>
            <div style={{flex: 1}} />
          </div>
          <div style={{padding: '16px', flex: 1, fontWeight: 600, textAlign: 'center'}}>
            {tn.lang.calKidChange(tn.familyMemberNames(kidChanges?.before, this.props.family), 
              tn.familyMemberNames(kidChanges?.now, this.props.family))}
          </div>
          <div className={classes.paneChangeDaysStep} style={{paddingBottom: '8px'}}>
            <IconButton disabled={true}><BackArrowIcon /></IconButton>
            <div>{tn.lang.calChange(0,changes.length)}</div>
            <IconButton onClick={() => this.setState({showKidChange:false})}  classes={{root:classes.paneChangeArrowButton}}
              disabled={(changes.length === 0)}>
              <ArrowIcon />
            </IconButton>
          </div>
        </div>
    );
  }

  private setStep(step:number) {
    if (step === -1 && this.props.kidChanges !== undefined) {
      this.setState({showKidChange:true, week:0});
      return;
    }
    const changes = this.props.changes;
    if (step < 0 || step >= changes.length) {return;}
    this.setState({step, week:0});
    const focusDate = new Date(changes[step].start);
    
    this.props.setCalendarHighlight([changes[step]]);
    const elmnt = document.getElementById(focusDate.getFullYear()+"-"+focusDate.getMonth());
    if (elmnt !== null) {
        setTimeout(() => elmnt.scrollIntoView({ behavior: 'smooth', block: 'center' }), 300);
    }
  }

  private moveStart(e:React.TouchEvent<HTMLDivElement>) {
    this.startPaneDrag(e.touches[0].screenY);
  }

  private moveMove(e:React.TouchEvent<HTMLDivElement>) {
    this.updatePaneDrag(e.touches[0].screenY);
  }

  private moveEnd(e:React.TouchEvent<HTMLDivElement>) {
    this.finishPaneDrag();
  }

  private handleMouseDown = (e:React.MouseEvent<HTMLDivElement>) => {
    if (e.button !== 0) {
      return;
    }
    this.isMouseDragging = true;
    this.startPaneDrag(e.screenY);
    window.addEventListener('mousemove', this.handleWindowMouseMove);
    window.addEventListener('mouseup', this.handleWindowMouseUp);
    window.addEventListener('blur', this.handleWindowMouseCancel);
  };

  private handleWindowMouseMove = (e:MouseEvent) => {
    if (!this.isMouseDragging) {
      return;
    }
    this.updatePaneDrag(e.screenY);
  };

  private handleWindowMouseUp = () => {
    if (!this.isMouseDragging) {
      return;
    }
    this.isMouseDragging = false;
    this.finishPaneDrag();
    this.detachMouseHandlers();
  };

  private handleWindowMouseCancel = () => {
    if (!this.isMouseDragging) {
      return;
    }
    this.isMouseDragging = false;
    this.finishPaneDrag();
    this.detachMouseHandlers();
  };

  private startPaneDrag(screenY:number) {
    this.paneStart = screenY;
    if (this.paneRef.current) {
      this.paneRef.current.style.transition = "unset";
    }
  }

  private updatePaneDrag(screenY:number) {
    const newY = screenY;
    const delta =  this.paneStart - newY;

    if (this.paneRef.current) {
      let newPaneHeight:number = this.paneHeight + delta;
      // the pane may follow the drag below its minimum height, releasing it there closes the pane
      if (newPaneHeight < 0) {newPaneHeight = 0;}
      if (window.innerHeight - newPaneHeight < 150) {newPaneHeight = window.innerHeight-150;}
  

      if (this.paneHeight !== newPaneHeight) {
        this.paneStart = newY;
        this.setHeight(newPaneHeight);
      }
    }
  }

  private finishPaneDrag() {
    this.paneStart=0;
    if (this.paneRef.current) {
      this.paneRef.current.style.transition = "all 0.5s";
    }
    if (this.paneHeight < PANE_MIN_HEIGHT - PANE_CLOSE_DISTANCE) {
      this.props.close();
    } else if (this.paneHeight < PANE_MIN_HEIGHT) {
      this.setHeight(PANE_MIN_HEIGHT);
    }
  }

  private detachMouseHandlers() {
    window.removeEventListener('mousemove', this.handleWindowMouseMove);
    window.removeEventListener('mouseup', this.handleWindowMouseUp);
    window.removeEventListener('blur', this.handleWindowMouseCancel);
  }
}



function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    family:state.family.family,
  };
}

export default connect(mapStateToProps)(withStyles(EditPaneStyle)(ShowChangesPane));



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/ShowChangesPane.tsx